(function () {
  'use strict';

  /* @ngdoc object
   * @name myPod.sendInvite
   * @description
   *
   */
  angular
    .module('myPod.sendInvite', [
      'ui.router'
    ]);
}());
